import { useLayoutEffect, useSyncExternalStore } from 'react';

import {
  coverSupportingPane,
  exposeSupportingPane,
  hasSupportingPaneRegion,
  subscribeSupportingPaneRegions,
} from './supportingPaneRegistry';

type SupportingPaneOverlayOptions = {
  isOpen: boolean;
  isFromSupportingPane: boolean;
};

type SupportingPaneOverlay = {
  isBesideSupportingPane: boolean;
};

export const useSupportingPaneOverlay = ({
  isOpen,
  isFromSupportingPane,
}: SupportingPaneOverlayOptions): SupportingPaneOverlay => {
  const hasRegion = useSyncExternalStore(
    subscribeSupportingPaneRegions,
    hasSupportingPaneRegion,
    hasSupportingPaneRegion,
  );

  useLayoutEffect(() => {
    if (!isOpen) return undefined;
    return isFromSupportingPane
      ? coverSupportingPane()
      : exposeSupportingPane();
  }, [isOpen, isFromSupportingPane]);

  return { isBesideSupportingPane: hasRegion && !isFromSupportingPane };
};
